import React, { Component } from 'react';
import { bool, func, object, string } from 'prop-types';

import { connect } from 'react-redux';

import ConfirmActionModal from './ConfirmActionModal';

import * as ArchitectActions from '../../actions/architectActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as UiActions from '../../actions/uiActions';

class DeleteClientModal extends Component {
    handleDelete = async () => {
        const { selectedNode, companyInfo } = this.props;

        let isDeleted;

        if (!this.props.isLoading) {
            this.props.toggleLoading(true);
            isDeleted = await this.props.deleteClient(selectedNode.id, companyInfo);
        }

        if (isDeleted) this.handleClose();
    }

    handleClose = () => {
        this.props.clearErrors();
        this.props.toggleLoading(false);
        this.props.close();
    }

    render() {
        const {
            errors,
            isLoading,
            open,
            selectedNode,
            title
        } = this.props;

        return (
            <ConfirmActionModal
                errors={errors}
                onClose={this.handleClose}
                onConfirm={this.handleDelete}
                open={open}
                title={title}
                isLoading={isLoading}
            >
                <p>
                    Warning: Deleting a Client will also delete all Campuses, Sites, Areas, Equipment, Systems, and Sensors tied to this Client.
                </p>
                <p>
                    Are you sure you want to delete Client: {selectedNode.name}?
                </p>
            </ConfirmActionModal>
        );
    }
}

DeleteClientModal.defaultProps = {
    selectedNode: {}
};

DeleteClientModal.propTypes = {
    close:        func.isRequired,
    open:         bool.isRequired,
    selectedNode: object,
    title:        string.isRequired
};

const mapStateToProps = state => {
    return {
        companyInfo:  state.companyInfo,
        errors:       state.messages.errors,
        isLoading:    state.ui.isLoading,
        selectedNode: state.architect.selectedNode
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ApplicationMessageActions,
    ...UiActions
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteClientModal);
